import { CoreUser } from './core-user.model';

export interface CoreAccount {
  id?: string;
  firstName: string;
  lastName: string;
  jobTitle?: string;
  phoneNumber?: string;
  company?: string;
  status: StatusType;
  accountType: AccountType;
  deleteRequestDate?: Date;
  client?: Client;
  user?: CoreUser;
  accountPermissions?: AccountPermission[];
}

interface Client {
  id?: string;
  name: string;
  logoUrl?: string;
  status: StatusType;
  modules: string[];
}

interface AccountPermission {
  projectId: string;
  project?: Project;
  modulePermissions: ModulePermission[];
}

interface Project {
  id?: string;
  name: string;
  abbreviation: string;
  logoUrl: string;
  status: StatusType;
  modules: string[];
}

interface ModulePermission {
  moduleId: string;
  isAdmin: boolean;
}

enum StatusType {
  Active = 1,
  Inactive,
}

enum AccountType {
  SystemAdmin = 1,
  ClientAdmin,
  ClientUser,
}
